import { createDrawerRouterSlice, getInitialDrawerRouterState } from 'slices/generic/createDrawerRouterSlice'
import { get } from 'lodash'
import routes from 'router/routes'

const inventoryDrawerSlice = createDrawerRouterSlice({
  name: 'inventoryDrawer',
  initialState: {
    ...getInitialDrawerRouterState({ favoriteUrl: routes.app.inventoryContainers }),
  },
  reducers: {},
})

export const {
  openDrawer: openInventoryDrawer,
  closeDrawer: closeInventoryDrawer,
  setFavoriteUrl: setFavoriteInventoryUrl,
} = inventoryDrawerSlice.actions

export const selectIsOpenInventoryDrawer = s => get(s, 'inventoryDrawer.isDrawerOpen', true)
export const selectInventoryFavoriteUrl = s => get(s, 'inventoryDrawer.favoriteUrl', routes.app.inventoryContainers)

export default inventoryDrawerSlice.reducer
